// src/pages/SuperAdminApp.js
// Super Admin dashboard — own JWT, no vendor/mall dependency
// Shown after super admin login

import React, { useState } from 'react';
import { useAuth }     from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import LangToggle      from '../components/LangToggle';
import SuperAdminPanel from './SuperAdminPanel';

export default function SuperAdminApp() {
  const { superAdmin, logout } = useAuth();
  const { isAr }               = useLanguage();

  return (
    <div>
      {/* Super admin nav */}
      <div className="nav" style={{ flexWrap:'wrap', gap:6, direction: isAr ? 'rtl' : 'ltr' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div className="nav-logo">⚡ QuickServe</div>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:10, background:'#2a1a3d', color:'#7F77DD' }}>
            Super Admin
          </span>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginLeft:'auto' }}>
          <LangToggle />
          <div style={{ fontSize:12, color:'var(--text2)' }}>
            ⚡ {superAdmin?.name || superAdmin?.email}
          </div>
          <button className="btn btn-ghost btn-sm" onClick={logout}>Logout</button>
        </div>
      </div>

      {/* Full super admin panel */}
      <SuperAdminPanel />
    </div>
  );
}
